import api from './api.js';

export const obter_produtos = async (cnpj_cpf, search_term, grupo, subgrupo, divisao, page, pageSize) => {
    try {
      const response = await api.get(`/Produtos`, {
        params: {
          cnpj_cpf_usuario: cnpj_cpf,
          search: search_term,
          grupo: grupo,
          subgrupo: subgrupo,
          divisao: divisao,
          page: page,
          pageSize: pageSize,
        }
      });

      if (response.data.sucesso) {
        return response.data;
      } else {
        throw new Error('Falha ao obter produtos.');
      }

    } catch (error) {
      console.error('Erro ao obter produtos: ', error.message);
      throw error;
    }
};

export const obtendo_preco_produto_atual = async (lista_produtos, cnpj_cpf_usuario) => {
  const lista_codigos = lista_produtos.map(p => p.coD_PROD);

  try {
    const response = await api.post('/Produtos/ObterValoresAtuaisProdutos', {
      lista_codigos,
      cnpj_cpf_usuario
    });

    if(response.data.sucesso){
      return response
    } else {
      throw new Error('Falha ao obter valores atualizados dos produtos');
    }

  } catch (error) {
    console.error('Erro ao obter valores atualizados dos produtos.', error.message);
    throw error;
  }
};

export const obtendo_preco_produto_atual_faturado = async (lista_produtos, cnpj_cpf_usuario) => {
  const lista_codigos = lista_produtos.map(p => p.proD_CODIGO);

  try {
    const response = await api.post('/Produtos/ObterValoresAtuaisProdutos', {
      lista_codigos,
      cnpj_cpf_usuario
    });

    if(response.data.sucesso){
      return response
    } else {
      throw new Error('Falha ao obter valores atualizados dos produtos');
    }

  } catch (error) {
    console.error('Erro ao obter valores atualizados dos produtos.', error.message);
    throw error;
  }
};